'use strict'

var regexCheck = require('../util/regex-check.js')

var unicodeWhitespace = regexCheck(/\s/)

module.exports = unicodeWhitespace
